import { API_URL } from 'src/config';
import { getDOMElement } from 'src/utils/DOM';
import { httpPost } from 'src/utils/http';

export const verificationTokenInput = getDOMElement("input[name='__RequestVerificationToken']") as HTMLInputElement;

export const setVerificationToken = (): Promise<void> =>
  httpPost(`${API_URL}/csrf/token`).then((response) => {
    if (response) {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(response as string, 'text/html');
      verificationTokenInput.value = htmlDoc.getElementsByTagName('input')[0].value;
    }
  });
